<template>
  <div class="gare-card">
    <div class="gare-card__head">
      <div class="gare-card__title">{{ gare.designation }}</div>
      <div class="gare-card__email">{{ gare.email }}</div>
    </div>

    <div class="gare-card__rows">
      <div class="gare-card__row">
        <span class="gare-card__label">Téléphone 1</span>
        <span class="gare-card__value">+225 {{ gare.telephone1 }}</span>
      </div>
      <div v-if="gare.telephone2" class="gare-card__row">
        <span class="gare-card__label">Téléphone 2</span>
        <span class="gare-card__value">+225 {{ gare.telephone2 }}</span>
      </div>
      <div class="gare-card__row">
        <span class="gare-card__label">Adresse</span>
        <span class="gare-card__value">{{ gare.adresseLocalisation }}</span>
      </div>
      <div v-if="showCompany" class="gare-card__row">
        <span class="gare-card__label">Compagnie</span>
        <span class="gare-card__value">{{ gare.compagnieTransportRaisonSociale }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardGareTransportView",

  props: {
    gare: {
      type: Object,
      required: true,
    },
    showCompany: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/admin/variables";

.gare-card {
  height: 100%;
  padding: 18px;
  background: #ffffff;
  border: 1px solid $ov-line;
  border-top: 3px solid $ov-green;
  border-radius: 12px;
  font-family: "Montserrat", sans-serif;
  transition: box-shadow 0.2s ease, transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 14px 28px -14px rgba(12, 36, 97, 0.25);
  }
}

.gare-card__head {
  padding-bottom: 14px;
  margin-bottom: 6px;
  border-bottom: 1px solid $ov-line;
}

.gare-card__title {
  font-size: 15px;
  font-weight: 800;
  color: $ov-navy;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gare-card__email {
  margin-top: 2px;
  font-size: 13px;
  color: $ov-green-dark;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gare-card__row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0;
  font-size: 13px;
}

.gare-card__label {
  flex-shrink: 0;
  color: $ov-muted;
}

.gare-card__value {
  font-weight: 700;
  color: $ov-ink;
  text-align: right;
  word-break: break-word;
}
</style>
